var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineBannerIcYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_4672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4341 2.16447L10.7324 7.96641H15.1194L17.5757 4.1877C18.1457 3.31091 17.885 2.13705 16.9975 1.58384C16.1284 1.04203 14.985 1.301 14.4341 2.16447Z",
    fill: "#FF9E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52531 12.6385L1.11069 8.95353C1.0154 8.10665 1.67807 7.36523 2.53031 7.36523H17.4714C18.3237 7.36523 18.9863 8.10665 18.891 8.95353L18.4764 12.6385C18.2619 14.5456 17.1247 16.1456 15.5404 17.0135C15.764 17.4519 15.9212 17.9322 15.9974 18.442C16.1032 19.147 15.557 19.7809 14.8442 19.7809H5.1574C4.44455 19.7809 3.89851 19.147 4.00411 18.442C4.08047 17.9322 4.23757 17.4519 4.46126 17.0135C2.87698 16.1455 1.73988 14.5456 1.52531 12.6385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8944 11.0735C10.8944 10.5804 10.4946 10.1807 10.0015 10.1807C9.50842 10.1807 9.10867 10.5804 9.10867 11.0735V12.6805H7.50223C7.00912 12.6805 6.60938 13.0802 6.60938 13.5733C6.60938 14.0665 7.00912 14.4663 7.50223 14.4663H9.10867V16.0731C9.10867 16.5662 9.50842 16.966 10.0015 16.966C10.4946 16.966 10.8944 16.5662 10.8944 16.0731V14.4663H12.5018C12.9949 14.4663 13.3947 14.0665 13.3947 13.5733C13.3947 13.0802 12.9949 12.6805 12.5018 12.6805H10.8944V11.0735Z",
    fill: "#FF9E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_4672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBannerIcYellow);
export default __webpack_public_path__ + "static/media/timeline-banner-ic-yellow.2abf799cef12043aaf7acf317d610e80.svg";
export { ForwardRef as ReactComponent };